import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';

interface IProps {
  open: boolean;
  handleClose: () => void;
}

export const TermsAndConditions: React.FC<IProps> = (props) => {
  const { open, handleClose } = props;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md">
      <DialogTitle>Terms &amp; Conditions</DialogTitle>
      <DialogContent>
        <div>
          <h3>1. Terms &amp; Conditions</h3>
          <div>
            <p>
              1.1 These terms and conditions apply between the person, firm,
              company or other entity specified on your booking form
              (&ldquo;you&rdquo; or &ldquo;your&rdquo;) and Procurement Leaders
              Limited (&ldquo;PL&rdquo; or &ldquo;we&rdquo;) a company
              registered in England &amp; Wales with company registration number
              05013101 and registered address of 3rd Floor Prospero House, 241
              Borough High Street, London, SE1 1GA, UK.
            </p>

            <p>
              1.2 PL is the owner, organiser, operator and/or manager of the
              event and these terms set out the conditions that apply to your
              purchase of a ticket and your attendance at the event and form an
              agreement between us (&ldquo;the agreement&rdquo;). Please read
              them carefully as they contain important information. By
              submitting your registration to attend the Event (&ldquo;your
              registration&rdquo;) you agree to be bound by these terms to the
              exclusion of all other terms. If you do not agree to be bound by
              these terms PL will be unable to accept your registration. PL may
              update these terms at any time for legal or regulatory reasons, or
              to reflect changes in PL services or business practices.
            </p>
          </div>
          <h3>2. Booking and reservation</h3>
          <div>
            <p>
              2.1 To reserve a place at the event as a delegate you should
              either complete the online booking form and complete the online
              payment process.
            </p>

            <p>
              2.2 All bookings will receive a confirmation email after payment
              has been confirmed. PL reserves the right to cancel your booking
              in the event of incorrect or incomplete payment, utilization of an
              invalid discount code, or any other reason that PL sees fit.
            </p>
          </div>
          <h3>3. Ticket prices</h3>
          <div>
            <p>
              3.1 PL reserves the possibility to change prices for the
              conference at any given time but changes will not affect tickets
              already purchased.
            </p>

            <p>
              3.2 If the payment has not been received by PL on the day of the
              event PL reserves the right to refuse admission to the event.
            </p>

            <p>
              3.3 If your booking is rejected, you will receive a booking
              rejection email and PL will refund any payment already made within
              a reasonable time from the date of the booking.
            </p>

            <p>3.4 All prices are subject to local taxes as appropriate.</p>
          </div>
          <h3>4. Refund and cancellation</h3>
          <div>
            <p>
              4.1 You have the right to cancel your purchase and request a full
              refund up to 7 days after the date of the purchase, except for
              purchases made within 45 days of the conference, when no refunds
              will be made.
            </p>

            <p>
              4.2 If for any reason, you are unable to attend the event we will
              allow you to provide for a substitute delegate to take your place.
              To make such a request please email{" "}
              <a href="mailto:delegate-sales@procurementleaders.com">
                delegate-sales@procurementleaders.com
              </a>
              . No substitutions are allowed within the last 7 days prior to the
              event.
            </p>
          </div>
          <h3>5. Changes to the event</h3>
          <div>
            <p>
              5.1 For reasons beyond PL&rsquo;s control, it may be necessary to
              alter the event&rsquo;s advertised format, content, location
              and/or timing. PL reserves the right to do this at any time but
              where PL changes the date or location of the event, PL will inform
              all delegates and provide the option to transfer attendance to a
              future event.
            </p>

            <p>
              5.2 PL is not liable for any travel, accommodation or other costs
              or expenses incurred by the delegates should PL need to relocate,
              cancel, postpone or alter in any other way the event.
            </p>
          </div>
          <h3>6. Content</h3>
          <div>
            <p>
              6.1 Any content including presentations, documentation, and
              materials is at all times owned by PL or is included with the
              permission of the owner of the rights. No filming, recording,
              photographing or republication, broadcast or other dissemination
              of the content is permitted.
            </p>

            <p>
              6.2 To the extent that any Content is made available by us online
              we reserve the right to suspend or remove access to such Content
              at any time.
            </p>

            <p>
              6.3 You acknowledge that PL will be entitled to record, film or
              photograph, the Event and agree to waive any rights arising under
              the laws of any jurisdiction. You grant to us an irrevocable,
              worldwide, royalty-free license to make such use of your name,
              voice, biography and likeness in any media and any recording,
              filming or photography of the Event as reasonably required in
              connection with the exploitation, advertising, and promotion of
              the Event and PL.
            </p>
          </div>
          <h3>7. No reselling</h3>
          <div>
            <p>
              7.1 All tickets purchased are for your own personal use or that of
              your business only. No tickets can be resold under any
              circumstance. Reselling or transferring any given ticket without
              permission or according to the terms, will void the ticket and the
              ticket holder will not have the right to enter into the
              conference.
            </p>

            <p>
              7.2 PL reserves the rights to void any ticket held by any person
              whom PL reasonably believes to be associated with any ticket
              reselling or a ticket broker.
            </p>
          </div>
          <h3>8. Privacy policy</h3>
          <div>
            <p>
              8.1 Please click{" "}
              <a href="https://www.procurementleaders.com/policies/privacy-policy">
                here
              </a>{" "}
              to see our privacy policy.
            </p>
          </div>
          <h3>9. Other</h3>
          <div>
            <p>
              9.1 PL is not responsible for any loss or damage to any person or
              any personal property directly or indirectly resulting from any of
              PL&rsquo;s events or activities.
            </p>

            <p>
              9.2 These Terms and Conditions and the rights and obligations of
              both parties shall be governed by and construed in accordance with
              the laws of Wales and England and both parties irrevocably agree
              to submit to the exclusive jurisdiction of the courts of England
              and Wales in respect of any dispute which arises hereunder.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
